import { call, select, takeEvery } from 'redux-saga/effects';
import {
  getEndpointUrl,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  NavigationRoute,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { FindProgrammteilnahmeBFFRequestModel, Role } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { CheckoutActions } from '../checkout.actions';
import { IAppState } from '../localStore';
import { shouldUseSdwEndpoint } from '../selector/transient-state.selector';

export function* watchProgrammteilnahmeRequest() {
  yield takeEvery(
    GlobalActions.LOCATION_CHANGED,
    safeSaga(requestProgrammteilnahme, App.SHOP_CHECKOUT),
  );
}

export function* requestProgrammteilnahme(action: GlobalAction<NavigationRoute>) {
  if (action.payload.appId !== App.SHOP_CHECKOUT) {
    return;
  }

  const state: IAppState = yield select();
  if (state.role !== Role.VERTRETER) {
    return;
  }

  const findProgrammteilnahmeBFFRequestModel: FindProgrammteilnahmeBFFRequestModel = {
    personId: state.kdv.perId,
    kundennummer: state.versicherungsnehmer.kundennummer,
    isEmailEditiert: false,
    email:
      state.versicherungsnehmer.email?.wert && state.versicherungsnehmer.email.wert !== ''
        ? state.versicherungsnehmer.email.wert
        : null,
  };

  state.transientState.programmteilnahmeResponseReceived = false;
  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    new GlobalActions().doRequest({
      appId: App.SHOP_CHECKOUT,
      body: findProgrammteilnahmeBFFRequestModel,
      url: getEndpointUrl(shouldUseSdwEndpoint(state), '/privatschutz/api/findprogrammteilnahme'),
      successEvent: CheckoutActions.PROGRAMMTEILNAHME_SUCCESS,
      errorEvent: CheckoutActions.PROGRAMMTEILNAHME_FAILED,
      noCache: true,
    }),
  );
}
